export enum AreaType {
  Clients,
  Regions,
  Locations,
  Units,
  Projects
}